(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('RegionalFranchiserFormController', RegionalFranchiserFormController)

    /** @ngInject */
    function RegionalFranchiserFormController($state, $stateParams, LoadingHelper, sweetAlert, UtilHelper, RegionalService) {
        const vm = this;
        const regionalId = $stateParams.regionalId;

        vm.saveRegional = () => {
            LoadingHelper.startLoading('.loading-holder');

            if (!vm.regionalData.Id) {
                RegionalService
                    .post(vm.regionalData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let regionalData = {
                    Id: regionalId,
                    ExternalCode: vm.regionalData.ExternalCode,
                    Description: vm.regionalData.Description
                };

                RegionalService
                    .put(regionalData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteRegional = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    RegionalService
                        .deleteData(regionalId)
                        .then(() => {
                            $state.go('app.franchiser-regionals-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getRegional() {
            if (!regionalId)
                return;

            LoadingHelper.startLoading('.loading-holder');

            RegionalService
                .get(regionalId)
                .then(success => {
                    vm.regionalData = success;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                vm.regionalData = success;

                $state.go('app.franchiser-regionals-edit', {
                    regionalId: vm.regionalData.Id
                }, {
                    notify: false
                });

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function init() {
            getRegional();
        }
    }
}());